// extracted by mini-css-extract-plugin
module.exports = {"root":"pending_root__1MItf","btnWrapper":"pending_btnWrapper__1bHCm","button":"pending_button__3h-B5","text":"pending_text__2Ulvn","dataTitle":"pending_dataTitle__2r2C5"};